// What the user is told when the issuers back office refuses a request. The server explains a refusal of the
// data with `{ "error": "<code>" }` (400/422): the codes it can answer are the ones listed here, each with its
// text under `configurations.issuers.errors`. A 404 says the issuer is no longer there (the list is stale).
//
// Used only by the issuers panel, not by the global httpErrorsHandler: elsewhere a 400 or a 404 does not
// mean a form to correct.

const BASE = 'configurations.issuers.errors.'
const GENERIC = 'common.genericError'

const KNOWN_CODES = [
  'IssuerCodeInvalid',
  'IssuerCodeInUse',
  'IssuerNameInvalid',
  'IssuerNameInUse',
  'IssuerNameFfkInvalid',
  'IssuerNameFfkInUse',
  'IvassCodeInvalid',
  'IvassCodeInUse',
  'AliasInvalid',
  'AliasInUse',
]

async function errorCodeOf(response) {
  try {
    const body = await response.json()
    return body && body.error
  } catch (e) {
    return null
  }
}

/**
 * @param {Error} err what the request threw
 * @returns {Promise<{ messageKey: string, stale: boolean }>} the text to show, and whether the list the user is
 *   looking at is out of date (the issuer has gone). A refusal the frontend does not know still says something.
 */
export async function describeIssuerError(err) {
  const response = err && err.response
  if (!response) {
    return { messageKey: GENERIC, stale: false }
  }
  if (response.status === 404) {
    return { messageKey: BASE + 'NotFound', stale: true }
  }

  const code = await errorCodeOf(response)
  if (KNOWN_CODES.includes(code)) {
    return { messageKey: BASE + code, stale: false }
  }
  return { messageKey: GENERIC, stale: false }
}
